<!-- Breadcrumb End -->
<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1>cart</h1>
            <ul>
                <li>
                    <a [routerLink]="['/dashboard']" style="color: #e04787;"><i class="fa fa-reply "
                            aria-hidden="true"></i>
                        Back</a>
                </li>
            </ul>
        </div>
    </div>
</div>
<!-- Breadcrumb Start -->

<!-- Cart Start -->
<div class="el-cart-wrapper">
    <div class="container">

        <div *ngIf="billingDetails.cartItems.length==0">
            <div class="wc-proceed-to-checkout text-center">
                <a class="el-btn" [routerLink]="['/product']">Continue Shopping</a>
            </div>
        </div>
        <div class="row" *ngIf="billingDetails.cartItems.length>0">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="woo-cart-table">
                    <div class="table-responsive">

                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>S.No.</th>
                                    <th>Discription</th>
                                    <th>Quantity</th>
                                    <th>Rate</th>
                                    <th>Discount </th>
                                    <th>Subtotal</th>
                                    <th>GST</th>
                                    <th>Total</th>
                                    <th>Remove</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let item of billingDetails.cartItems; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td>
                                        <div class="d-flex">
                                            <img class="card-img-top img-fluid rounded mx-auto d-block"
                                                [src]="item.imageURL" alt="Book Image"
                                                style="height: 140px; object-fit: contain;">
                                            {{ item.book_title }}
                                        </div>

                                    </td>
                                    <td>{{ item.quantity }}</td>
                                    <td>{{ item.unitPrice }}</td>
                                    <td>({{ item.discount }}%): {{ item.discountAmount| number:'1.2-2' }}
                                    </td>
                                    <td><i class="fas fa-rupee-sign"></i>&nbsp; {{ item.unitPrice-item.discountAmount }}
                                    </td>
                                    <td>({{ item.gst }}%): {{ item.gstAmount| number:'1.2-2' }}</td>
                                    <td><i class="fas fa-rupee-sign"></i>&nbsp; {{
                                        item.unitPrice-item.discountAmount+item.gstAmount|
                                        number:'1.2-2' }}
                                    <td>
                                        <a class="text-white bg-danger" style="cursor: pointer;"
                                            (click)="removeItem(i)">x</a>

                                    </td>
                                </tr>


                            </tbody>


                        </table>

                    </div>
                </div>
            </div>

            <div class="ed_cart_collaterals">
                <div class="cart_totals">
                    <h2>Cart Details
                    </h2>
                    <table class="table table-bordered">
                        <tbody>
                            <tr class="cart-subtotal ">
                                <th>Gross Amount</th>
                                <td><span class="amount text-dark">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i
                                            class="fas fa-rupee-sign"></i>&nbsp;
                                        {{
                                        billingDetails.grossAmount
                                        |
                                        number:
                                        '1.2-2' }}</span></td>
                            </tr>
                            <tr class="cart-subtotal" *ngIf="billingDetails.discountAmount>0">
                                <th>Discount Amount</th>
                                <td><span class="amount text-danger"><i class="fa fa-minus"></i>&nbsp;<i
                                            class="fas fa-rupee-sign"></i>&nbsp;{{
                                        billingDetails.discountAmount}}</span></td>
                            </tr>
                            <tr class="cart-subtotal">
                                <th>GST Amount</th>
                                <td><span class="amount text-dark">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i
                                            class="fas fa-rupee-sign"></i>&nbsp; {{
                                        billingDetails.gstAmount |
                                        number:
                                        '1.2-2' }}</span></td>
                            </tr>
                            <tr class="order-total">
                                <th>Total Payable</th>
                                <td><span class="amount">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i
                                            class="fas fa-rupee-sign"></i>&nbsp; <b>{{
                                            billingDetails.netAmount | number: '1.2-2' }}</b></span></td>
                            </tr>


                        </tbody>
                    </table>

                    <div class="el-placeorder-btn d-flex justify-content-between">
                        <a class="el-btn" [routerLink]="['/product']">Continue Shopping</a>
                        <a class="el-btn" [routerLink]="['/checkout']">Proceed to Checkout</a>

                    </div>

                </div>
            </div>

        </div>
    </div>
</div>
<!-- Cart End -->